<template>
  <div id="breakdown-item-list">
    <div class="breakdown-item"
         v-if="approvedAtDealership.count">
      <div class="row">
        <div class="previous">
          <p class="item">
            {{ $t("services_approved_at_dealership") }}
          </p>
          <button class="toggle"
                  @click="toggleApprovedAtDealership()">
            <img class="chevron"
                 :class="{'open' : approvedAtDealershipExpanded}"
                 src="@/assets/images/chevron-down.svg"
                 aria-hidden="true">
          </button>
        </div>
        <p class="item">
          {{ approvedAtDealership.total }}
        </p>
      </div>
      <div v-if="approvedAtDealershipExpanded"
           class="list">
        <div v-for="service in servicesApprovedAtDealership.filter(service => service.id !== '-1')"
             :key="service.id"
             class="row">
          <p class="item">
            {{ service.name }}
          </p>
          <p v-if="getServiceDisplayPrice(service)"
             class="item">
            {{ getServiceDisplayPrice(service) }}
          </p>
        </div>
      </div>
      <div v-if="servicesApprovedAtDealership.length"
           class="divider" />
    </div>
    <div class="breakdown-item">
      <div class="row bold">
        <div class="previous">
          <p class="item">
            {{ $t("estimate") }} ({{ firstApprovedServices.length }})
          </p>
          <button v-if="firstApprovedServices.length"
                  class="toggle"
                  @click="toggleFirstApproved()">
            <img class="chevron"
                 :class="{'open' : firstApprovedExpanded}"
                 src="@/assets/images/chevron-down.svg"
                 aria-hidden="true">
          </button>
        </div>
        <p :class="{
              'item': allServicesSelected,
              'unconfirmed-item': !allServicesSelected
            }">
          {{ formatCurrency(this.$store.getters.total.inspection) }}
        </p>
      </div>
      <div v-if="firstApprovedExpanded && firstApprovedServices.length"
           class="list">
        <div v-for="service in firstApprovedServices"
             :key="service.id"
             class="row">
          <p class="item">
            {{ service.name }}
          </p>
          <p v-if="getServiceDisplayPrice(service)"
             class="item">
            {{ getServiceDisplayPrice(service) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getTotal, formatCurrency, getServiceDisplayPrice, services } from '@/mixins.js'
  export default {
    name: 'BreakdownItem',
    mixins: [getTotal, formatCurrency, getServiceDisplayPrice, services],
    props: {
      totalInspection: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        firstApprovedExpanded: false,
        approvedAtDealershipExpanded: false
      }
    },
    computed: {
      approvedAtDealership() {
        let services = this.servicesApprovedAtDealership.filter(service => service.id !== '-1')
        let total = this.getTotal(services)
        return {
          services,
          count: services.length,
          total: this.formatCurrency(total)
        }
      },
      allServicesSelected() {
        return this.services()
      },
      ...mapGetters([
        'categoryServicesShownOnRoute',
        'categoriesShown',
        'servicesApprovedAtDealership',
        'firstApprovedServices',
        'isPass'
      ])
    },
    methods: {
      toggleApprovedAtDealership() {
        this.approvedAtDealershipExpanded = !this.approvedAtDealershipExpanded
      },
      toggleFirstApproved() {
        this.firstApprovedExpanded = !this.firstApprovedExpanded
      }
    }
  };
</script>

<style lang="scss" scoped>
  .breakdown-item {
    background-color: var(--white);
    box-shadow: var(--shadow-light);
    padding: 1rem;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.indented {
      padding-left: 3rem;

      .item {
        margin: 0.5rem 0;
      }
    }

    .unconfirmed-item {
      color: var(--grey-text);
    }

    .previous {
      display: flex;
      align-items: center;

      .toggle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 0 1rem;
        border: none;
        padding: 1.5rem 1rem;
        background-color: var(--white);

        .chevron {
          transition: transform .2s ease-in-out;
          max-width: 2rem;

          &.open {
            transform: rotate(180deg);
            transition: transform .2s ease-in-out;
          }
        }
      }
    }
  }

  .list {
    background-color: var(--grey-light-background);
    padding: 1rem;
  }

  .divider {
    width: 100%;
    height: 2px;
    margin: 1rem 0;
    background-color: var(--grey-light-background)
  }
</style>
